import React from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "./AuthContext";
import "./AuthStatus.css";

export const AuthStatus: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, userData, logout } = useAuthContext();

  if (isLoading) {
    return (
      <div className="auth-status loading">
        <div className="auth-spinner"></div>
      </div>
    );
  }

  if (isAuthenticated && userData) {
    const displayName = userData.firstName || userData.email?.split("@")[0] || "User";

    return (
      <div className="auth-status authenticated">
        <div className="user-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <span className="user-name">{displayName}</span>
        <button onClick={logout} className="auth-logout-btn" title={t("auth.status.signOut")}>
          <svg className="auth-logout-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" fill="currentColor"/>
          </svg>
          {t("auth.status.signOut")}
        </button>
      </div>
    );
  }

  return null;
};

export default AuthStatus;
